(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("brandNavigatorService", BrandNavigatorService);
    BrandNavigatorService.$inject = ['$q'];

    function BrandNavigatorService($q) {
        var self = this;
        self.searchBrandsData = {
            'per_page': 0,
            'total': -1,
            'last_page': 0,
            'current_page': 0,
            'brands': [],
        };
        var searchBrandsResultsViewData = [];
        var BRAND_SEARCH_PAGINATION_LIMIT = 10;
        var searchRequestId = 0;

        var prepareSearchResults = function (highestBrandId, brands) {
            var searchResults = [];

            for (var i = 0; i < brands.length; i++) {
                var brand = brands[i];
                var brandTreeWithAccess = [];
                var parentBrandsWithAccess = [];
                var parentBrands = brand.parents || [];

                brandTreeWithAccess.unshift({id: brand.id, type: brand.type, name: brand.name});

                if (brand.id != highestBrandId) {
                    for (var j = 0; j < parentBrands.length; j++) {
                        var brandDetails = {
                            id: parentBrands[j].id,
                            type: parentBrands[j].type,
                            name: parentBrands[j].name
                        };

                        brandTreeWithAccess.unshift(brandDetails);
                        parentBrandsWithAccess.push(brandDetails);

                        if (parentBrands[j].id == highestBrandId) {
                            break;
                        }
                    }
                }
                searchResults.push(brandTreeWithAccess);
                brand.parents = parentBrandsWithAccess;
            }

            return searchResults;
        };

        var searchBrandTree = function (brandId, searchTerm, includeArchivedLocations) {
            var defer = $q.defer();

            searchRequestId++;
            var requestId = searchRequestId;

            BrandAPI.searchBrandTree(brandId, self.searchBrandsData.brands.length, BRAND_SEARCH_PAGINATION_LIMIT, searchTerm, true, includeArchivedLocations)
                .then(function (results) {
                    if (searchRequestId === requestId) {
                        defer.resolve(results);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };


        self.getSearchBrandsResultsViewData = function (brandId, searchTerm, includeArchivedLocations) {
            var defer = $q.defer();

            searchBrandTree(brandId, searchTerm, includeArchivedLocations)
                .then(function (results) {
                    self.searchBrandsData.per_page = results.per_page;
                    self.searchBrandsData.total = results.total;
                    self.searchBrandsData.last_page = results.last_page;
                    self.searchBrandsData.current_page = results.current_page;
                    self.searchBrandsData.brands = self.searchBrandsData.brands.concat(results.brands);
                    var brandsViewData = prepareSearchResults(brandId, results.brands || []);
                    searchBrandsResultsViewData = searchBrandsResultsViewData.concat(brandsViewData);
                    defer.resolve(searchBrandsResultsViewData);
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.reset = function () {
            self.searchBrandsData = {
                'per_page': 0,
                'total': -1,
                'last_page': 0,
                'current_page': 0,
                'brands': [],
            };
            searchBrandsResultsViewData = [];
        };

    }
})();